import React from 'react';
import Popover from '../Popover';
import TreeSelectionListInner from './components/TreeSelectionListInner';
import TreeSelectionListDefaultActivator from './components/TreeSelectionListDefaultActivator';

const TreeSelectionList = ({
  activatorElement,
  items,
  onItemSelected,
  value,
  globalSearch,
  dataId,
  hideSelected,
  grouped,
  onItemSearch,
  searchValue,
  activatorText,
  isLoading,
  onClose,
  disabled,
  t,
  renderAfterListElement,
}) => (
  <Popover
    activatorElement={activatorElement || (<TreeSelectionListDefaultActivator dataId={`${dataId}.button`} current={activatorText} disabled={disabled} />)}
    noPadding
    childToggle={{ onItemSelected: () => (true) }}
    dataId={dataId}
    onClose={onClose}
    focusOrder={[globalSearch ? 'content' : 'reference']}
    disabled={disabled}
  >
    {close => (
      <TreeSelectionListInner {...{
        activatorElement,
        items,
        onItemSelected,
        value,
        globalSearch,
        dataId,
        hideSelected,
        grouped,
        onItemSearch,
        searchValue,
        isLoading,
        t,
        renderAfterListElement,
        close,
      }}
      />
    )}
  </Popover>
);

TreeSelectionList.defaultProps = {
  items: [],
  onItemSelected: () => {},
  value: [],
  globalSearch: false,
  hideSelected: false,
  dataId: 'TreeSelectionList',
  grouped: false,
  onItemSearch: () => {},
  searchValue: '',
  isLoading: false,
  onClose: () => {},
  renderAfterListElement: () => {},
};

export default TreeSelectionList;
